import React, { useEffect, useState } from 'react';
import './table.scss';
import { useTranslation } from 'react-i18next';

const Table = ({
	data,
	column,
	redirectTo,
	handleScroll,
	loading,
	totalRecords,
	onSortedList,
	variant = 'default',
}) => {
	const { t } = useTranslation();
	const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

	const handleSort = (key) => {
		let direction = 'asc';
		if (sortConfig.key === key && sortConfig.direction === 'asc') {
			direction = 'desc';
		}
		setSortConfig({ key, direction });
	};

	const sortedData = () => {
		const sortableData = [...data];
		if (sortConfig.key) {
			sortableData.sort((a, b) => {
				if (a[sortConfig.key] < b[sortConfig.key]) {
					return sortConfig.direction === 'asc' ? -1 : 1;
				}
				if (a[sortConfig.key] > b[sortConfig.key]) {
					return sortConfig.direction === 'asc' ? 1 : -1;
				}
				return 0;
			});
		}
		return sortableData;
	};

	useEffect(() => {
		const sorted = sortedData();
		onSortedList(sorted);
	}, [sortConfig]);

	const getCellStyle = (col) => {
		const style = {
			textAlign: col.align || 'left',
			verticalAlign: 'top',
		};
		if (col.width) {
			style.width = col.width;
		}
		return style;
	};

	const wrapperClass = variant === 'modern' ? 'table-modern-wrapper' : '';

	return (
		<div className={wrapperClass}>
			<div className='list-body' onScroll={handleScroll}>
				<table className={`custom-table${variant === 'modern' ? ' custom-table--modern' : ''}`}>
					<thead>
						<tr className='header-row'>
							{column.map((tableHead, index) => (
								<th key={index} style={getCellStyle(tableHead)}>
									{tableHead.HeadCell ? (
										tableHead.HeadCell({ value: tableHead.heading, row: data[index] })
									) : (
										<div
											onClick={() => handleSort(tableHead.accessor)}
											className='heading-container'
										>
											{tableHead.heading}
										</div>
									)}
								</th>
							))}
						</tr>
					</thead>
					<tbody className='table-body'>
						{data?.length > 0 ? (
							data.map((row, index) => (
								<tr
									onClick={redirectTo ? () => redirectTo(row) : null}
									key={index}
								>
									{column.map((tableData, colIndex) => (
										<td key={colIndex} style={getCellStyle(tableData)}>
											{tableData.Cell
												? tableData.Cell({ value: row[tableData.accessor], row })
												: row[tableData.accessor]}
										</td>
									))}
								</tr>
							))
						) : data?.length != 0 ? (
							<tr>
								<td colSpan={12} />
							</tr>
						) : (
							<tr>
								<td colSpan={column.length}>
									<div className='no-data-found'>
										<p>{t('no_data_found')}</p>
									</div>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default Table;
